import { render } from "./link-sheet.vue?vue&type=template&id=2a8a4824"
import script from "./link-sheet.vue?vue&type=script&lang=js"
export * from "./link-sheet.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__